import { Library } from "@fortawesome/fontawesome-svg-core";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import {
  faLanguage,
  faFont,
  faImage,
  faArrowRight,
  faBrain,
  faClock,
  faPlus,
  faGlobeAmericas,
  faEquals,
  faSmile,
  faHeart,
  faDonate,
  faBolt,
  faEnvelopeOpen,
  faKey,
  faSpinner,faBars,faUndo,faFileDownload
} from "@fortawesome/free-solid-svg-icons";

export function initialize(library: Library) {
  library.add(
    faLanguage,
    faFont,
    faImage,
    faArrowRight,
    faBrain,
    faClock,
    faPlus,
    faEquals,
    faSmile,
    faHeart,
    faDonate,
    faGoogle,
    faBolt,
    faGlobeAmericas,
    faEnvelopeOpen,
    faKey,
    faSpinner,faBars,faUndo,faFileDownload
  );
}
